import { connect } from 'react-redux';
import { getUserConfiguration } from './../reducers/profile';
import { updateUserConfiguration } from '../actions/profile';
import CustomNavComponent from './../Components/CustomNavComponent.jsx';

export const mapStateToProps = (state) => (
  { userConfiguration: getUserConfiguration(state) }
);

export const mapDispatchToProps = (dispatch) => (
  {
    submitOptions: (config) =>
      dispatch(updateUserConfiguration(config))
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomNavComponent);



// WEBPACK FOOTER //
// src/Containers/CustomNavContainer.jsx